export const loadSwitchers = () => {
  document.querySelectorAll('.switcher').forEach((div) => {
    new Switcher(div);
  });
};

class Switcher {
  constructor(div) {
    this.div = div;
    this.btns = [];
    div.querySelectorAll('.switcher__btn').forEach(this.setupBtn);
    this.currentTab = div.querySelector('.primary');
  }

  setupBtn = (btn) => {
    this.btns.push(btn);
    btn.addEventListener('click', this.btnClick);
  };

  btnClick = (e) => {
    e.preventDefault();
    const btn = e.target;
    const tabSelector = btn.classList.contains('switcher__btn--back') ? '.primary' : `#${btn.dataset.switcherId}`;

    this.switchTab(tabSelector);
  };

  switchTab = (selector) => {
    const newTab = this.div.querySelector(selector);
    if (newTab === this.currentTab) return;
    this.hideAll();
    if (!newTab.classList.contains('primary')) this.div.querySelector('.back').classList.add('active');
    newTab.classList.add('active');
    this.currentTab = newTab;
  };

  hideAll = () => {
    this.div.childNodes.forEach((c) => {
      c.classList.remove('active');
    });
  };
}
